import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import Icon from '../components/Icon/Icon.js';

var IconChat = function IconChat(_ref) {
  var title = _ref.title,
      filled = _ref.filled,
      otherProps = _objectWithoutProperties(_ref, ["title", "filled"]);

  return /*#__PURE__*/React.createElement(Icon, otherProps, filled ? /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 3h30a3.01 3.01 0 012.995 2.824L39 6v3h3a3.01 3.01 0 012.995 2.824L45 12v21a3.01 3.01 0 01-2.824 2.995L42 36h-3v7.5a1.5 1.5 0 01-2.448 1.162l-.112-.101L27.879 36h-15.88a3.01 3.01 0 01-2.994-2.824L9 33v-3H6a3.01 3.01 0 01-2.995-2.824L3 27V6a3.01 3.01 0 012.824-2.995L6 3h30H6zm30 3H6v21h3V12a3.01 3.01 0 012.824-2.995L12 9h24V6z"
  })) : /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 3h30a3.01 3.01 0 012.995 2.824L39 6v3h3a3.01 3.01 0 012.995 2.824L45 12v21a3.01 3.01 0 01-2.824 2.995L42 36h-3v7.5a1.5 1.5 0 01-2.448 1.162l-.112-.101L27.879 36h-15.88a3.01 3.01 0 01-2.994-2.824L9 33v-3H6a3.01 3.01 0 01-2.995-2.824L3 27V6a3.01 3.01 0 012.824-2.995L6 3h30H6zm36 9H12v21h17.109l6.89 6.879V33h6V12zm-6-6H6v21h3V12a3.01 3.01 0 012.824-2.995L12 9h24V6z"
  })));
};

export default IconChat;
